import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityTabs } from '@/common/entityFramework/entityTabs/EntityTabs';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useCtrtOutline } from '@/md/entities/ctrt/useCtrtOutline';
import { ProgContextStrip } from '@/md/entities/prog/ProgContextStrip';
import { useEffect, useState } from 'react';
import { ProgProdTierForm } from './ProgProdTierForm';

export const ProgProdTierDetail = () => {
  const { entityObj } = useEntityMgr();
  const rsrc = useRsrc();
  const [progObj, setProgObj] = useState(null);
  const [progProdObj, setProgProdObj] = useState(null);

  // The Tier's owner is a Program Product; walk up to its Program for the surrounding context.
  useEffect(() => {
    let current = true;
    setProgObj(null);
    setProgProdObj(null);

    const progProdId = entityObj?.progProdId;
    if (!progProdId) return;

    rsrc.byId('md', 'PROG_PROD', progProdId).then((owner) => {
      // The owner can be gone, since deleting a Program Product leaves its Tiers behind
      if (!current || !owner) return;

      setProgProdObj(owner);
      rsrc.byId('md', 'PROG', owner.progId).then((prog) => {
        if (current) setProgObj(prog);
      });
    });

    return () => {
      current = false;
    };
  }, [entityObj?.progProdId]);

  // An implemented Tier keeps the ctrtId of the Amendment it was authored on, so the Contract comes from the owner
  const ctrtId = progProdObj?.ctrtId ?? progObj?.ctrtId;

  const { augButtons, outlineContent } = useCtrtOutline({
    ctrtId,
    entity: 'PROG_PROD_TIER',
    entityId: entityObj.id,
  });

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <ProgProdTierForm /> },
    {
      id: 'entityProps',
      label: 'Properties',
      content: <EntityPropList parentEntity="PROG_PROD_TIER" parentEntityObj={entityObj} />,
    },
  ];

  return (
    <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons}>
      {outlineContent ?? (
        <>
          <ProgContextStrip ctrtId={ctrtId} progObj={progObj} progProdObj={progProdObj} />
          <EntityTabs tabSpecs={tabSpecs} />
        </>
      )}
    </EntityDetail>
  );
};
